const SelectorArrowSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M4.59019 6.10749C4.5568 6.07316 4.51751 6.04631 4.47458 6.02849C4.43165 6.01068 4.38592 6.00223 4.33999 6.00365C4.29406 6.00506 4.24884 6.0163 4.2069 6.03673C4.16497 6.05716 4.12714 6.08638 4.09558 6.12272C4.06402 6.15905 4.03935 6.2018 4.02298 6.24851C4.0066 6.29522 3.99884 6.34498 4.00014 6.39495C4.00144 6.44493 4.01177 6.49413 4.03055 6.53976C4.04933 6.58539 4.07618 6.62655 4.10957 6.66088L7.25773 9.89597C7.32267 9.96278 7.40866 10 7.49803 10C7.58741 10 7.6734 9.96278 7.73834 9.89597L10.8868 6.66088C10.921 6.62677 10.9485 6.58562 10.9679 6.53983C10.9873 6.49403 10.9981 6.4445 10.9998 6.39411C11.0014 6.34372 10.9939 6.29348 10.9775 6.2463C10.9611 6.19912 10.9363 6.15595 10.9045 6.11929C10.8727 6.08263 10.8345 6.05322 10.7922 6.03275C10.7498 6.01229 10.7042 6.00119 10.6578 6.00009C10.6115 5.99899 10.5654 6.00792 10.5223 6.02636C10.4792 6.0448 10.4398 6.07238 10.4066 6.10749L7.49803 9.09595L4.59019 6.10749Z"
        fill="#333333"
        stroke="#333333"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export default SelectorArrowSvg;
